// extracted by mini-css-extract-plugin
export default {"container":"_e6fdbee5"};